import React from 'react';
import { Wizard } from '../../../../../design-system';
import { ConfirmationStep } from './components/ConfirmationStep';
import { DetailsStep } from './components/DetailsStep';
import { CreateLocationContext } from './CreateLocationContext';
import type { CreateLocationWizardState } from './types';
import { LocationDetails } from '../CreateChargePoint/types';

interface CreateLocationFormProps {
  onCreated: (location: LocationDetails) => void;
  onExit: () => void;
}

export const CreateLocationForm: React.FC<CreateLocationFormProps> = ({ onCreated, onExit }) => (
  <CreateLocationContext.Provider value={{ onCreated }}>
    <Wizard<CreateLocationWizardState>
      steps={[
        { id: 'details', label: 'Details', view: DetailsStep },
        { id: 'confirmation', label: 'Confirmation', view: ConfirmationStep },
      ]}
      onExit={onExit}
      hasStepper
    />
  </CreateLocationContext.Provider>
);
